import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="bg-[#F5F1EC] py-28 md:py-36 px-8 md:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-stretch">

          {/* Image */}
          <div className="lg:col-span-4 relative">
            <div className="w-full h-[420px] lg:h-full min-h-[460px] overflow-hidden">
              <img
                key={t.id}
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover object-top transition-opacity duration-500"
              />
            </div>
          </div>

          {/* Quote */}
          <div className="lg:col-span-8 flex flex-col justify-between lg:pl-16 xl:pl-24 py-4 md:py-8">
            <div>
              <span className="font-serif text-[#C9A961]/30 text-8xl leading-none block mb-2">"</span>
              <blockquote className="font-serif text-[#1A1A1A] text-2xl md:text-3xl lg:text-[2rem] leading-[1.45] font-light -mt-4">
                {t.quote}
              </blockquote>
            </div>

            <div className="mt-12">
              <div className="h-px w-10 bg-[#C9A961] mb-7" />
              <p className="font-serif text-[#1A1A1A] text-base">{t.name}</p>
              <p className="text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mt-1">{t.title}</p>

              {/* Navigation */}
              <div className="flex items-center gap-5 mt-10">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActive(i)}
                    aria-label={`Testimonial ${i + 1}`}
                    className={`transition-all duration-300 cursor-pointer ${
                      i === active
                        ? "h-px w-10 bg-[#C9A961]"
                        : "h-px w-5 bg-[#C4B5A0] hover:bg-[#8A7F74]"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
